import { useMutation } from "@tanstack/react-query";

import { authApi } from "@/features/identity/services/auth.api";
import { setAccessToken } from "@/lib/token-storage";
import { useAppDispatch } from "@/store/hooks";
import { setCredentials } from "@/store/auth/authSlice";

/**
 * Storing the returned session (token + Redux `auth` state) lives here, not
 * in `LoginPage` — every caller of "login" should persist credentials the
 * same way. Where to navigate *after* is page-specific (a `?redirect=`
 * target vs. always Home), so that stays a per-call `onSuccess` passed to
 * `mutate()` in the page, not baked in here.
 */
export function useLogin() {
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: authApi.login,
    onSuccess: (session) => {
      setAccessToken(session.accessToken);
      dispatch(setCredentials({ user: session.user }));
    },
  });
}
